import { EMAIL_REGEXP_THAT_WORKS } from '@orgbrain/lib-data';
import { Entity, ShareholderEvent, ShareholderRecord } from './classes';
import { Entities } from './model/entity';
import { initNumbersRaw, ShareNumbers } from './numbers';

export class ShareholderUtils {
  public static keepEventsAfterDate({
    date,
    events,
  }: {
    date: Date;
    events: ShareholderEvent[];
  }): ShareholderEvent[] {
    return events.filter((event: ShareholderEvent) => new Date(event.date) > date);
  }

  public static setHasDuplicateNames(entities: Entity[]): Entity[] {
    let entityMap = entities.reduce((acc: any, entity: Entity): any => {
      let name = Entities.getEntityName(entity);
      if (acc[name]) {
        acc[name].push(entity);
      } else {
        acc[name] = [entity];
      }
      return acc;
    }, {});

    let lst: Entity[] = [];

    for (let key of Object.keys(entityMap)) {
      if (entityMap[key].length > 1) {
        let newEntities = entityMap[key].map((entity: Entity) => ({
          ...entity,
          hasDuplicateName: true,
        }));
        lst.concat(newEntities);
      } else {
        lst.concat(entityMap[key]);
      }
    }
    return lst;
  }

  public static getIncorrectImails(entities: Entity[]): string[] {
    const wrongEmails = entities
      .filter((ent) => {
        if (!ent?.email) {
          return false;
        }

        if (!isEmailValid(ent.email)) {
          return true;
        } else {
          return false;
        }
      })
      .map((ent) => ent.email);

    return wrongEmails;
  }

  public static countDuplicateNames(entities: Entity[]): number {
    return entities.reduce(
      (count: number, entity: any) => (entity.hasDuplicateNames ? count + 1 : count),
      0
    );
  }

  public static getSharenumbersFromNote(note: string): { from: string; to: string }[] {
    return note.split(',').map((interval: string) => {
      let [from, to] = interval.split('-');
      return { from, to };
    });
  }

  public static displaySharenumberAsString(sharenumber: ShareNumbers): string {
    if (+sharenumber.from + 1 === +sharenumber.to) {
      return sharenumber.to + '';
    }
    return +sharenumber.from + 1 + '-' + sharenumber.to;
  }

  public static displaySharenumbersAsString(sharenumbers: ShareNumbers[]): string {
    if (sharenumbers) {
      return sharenumbers.map(this.displaySharenumberAsString).join(', ');
    } else {
      return '';
    }
  }

  public static generateSharenumberNotes(records: ShareholderRecord[]): ShareholderRecord[] {
    let newRecords = initNumbersRaw({ records: [...records], timeStamp: null, eventRef: null });
    return newRecords.map((record: ShareholderRecord): ShareholderRecord => {
      return {
        ...record,
        notes: this.displaySharenumbersAsString(record.numbers as any),
      };
    });
  }

  // TODO! Need to refactor to use optionalTranslationService.isSpecialCaseCompany()
  public static isFliEsekOrBrl(orgType: string) {
    return orgType === 'ESEK' || orgType === 'BRL' || orgType === 'FLI' || orgType === 'NIF';
  }

  // TODO! Need to refactor to use optionalTranslationService.isSpecialCaseCompany()
  public static isNotFliEsekOrBrl(orgType: string) {
    return (
      orgType !== 'ESEK' &&
      orgType !== 'BRL' &&
      orgType !== 'FLI' &&
      orgType !== 'NIF' &&
      orgType !== 'SA' &&
      orgType !== 'STI' &&
      orgType !== 'SBSTI'
    );
  }

  public static entityHasDetailFields(entityRecord: Entity & ShareholderRecord): boolean {
    return !!(
      entityRecord.numbers ||
      entityRecord.notes ||
      entityRecord.address ||
      entityRecord.banknr ||
      entityRecord.city ||
      entityRecord.zip ||
      entityRecord.tlf
    );
  }
  public static tousandSeperator(val: number) {
    if (val !== undefined && val !== null) {
      const formatter = new Intl.NumberFormat('nb-NO', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      let res = formatter.format(val);
      if (/.+,[0-9]{1}$/.test(res)) {
        res += '0';
      }

      return res;
    } else {
      return '';
    }
  }
}

function isEmailValid(email) {
  const test =
    // eslint-disable-next-line no-useless-escape
    EMAIL_REGEXP_THAT_WORKS;
  return test.test(email);
}
